import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.999 3.698a.7.7 0 0 1 .7-.7h12.603a.7.7 0 0 1 .7.7v4.784a.7.7 0 1 1-1.4 0v-.933H4.399v8.053H9a.7.7 0 1 1 0 1.4H3.699a.7.7 0 0 1-.7-.7V3.698Zm1.4 2.451h11.203V4.4H4.399v1.75Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.699 2.998a.7.7 0 0 0-.7.7v12.604a.7.7 0 0 0 .7.7H9a.7.7 0 1 0 0-1.4H4.399V7.548h11.203v.933a.7.7 0 1 0 1.4 0V3.698a.7.7 0 0 0-.7-.7H3.699Zm.7 3.151V4.4h11.203v1.75H4.399Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.578 10.173a.7.7 0 0 1 .07.988l-.643.739h3.76l-.642-.74a.7.7 0 1 1 1.057-.918l1.65 1.898a.7.7 0 0 1 0 .919l-1.65 1.898a.7.7 0 0 1-1.057-.919l.642-.738h-3.76l.642.738a.7.7 0 0 1-1.056.919l-1.65-1.898a.7.7 0 0 1 0-.919l1.65-1.898a.7.7 0 0 1 .987-.069Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
